export default __webpack_public_path__ + "static/media/slt1-min.9d727fab.jpg";